import InitByDevisWsContainer from './InitByDevisWsContainer';
//todo mettre le formulaire direct
const App = () => {
    return <InitByDevisWsContainer />;
};

export default App;
